export const useGuestCars = async () => {
  const client = useClient()

  const filters = ref({})
  const data: any = ref([])
  const total = ref(0)
  const isLoading = ref(false)

  const {
    currentPage,
    currentPageSize,
    pageCount,
    isFirstPage,
    isLastPage,
    prev,
    next,
  } = useOffsetPagination({
    total,
    page: 1,
    pageSize: 10,
    onPageChange: fetchData,
    onPageSizeChange: fetchData,
  });

  async function fetchData(input = {}) {
    isLoading.value = true
    const {currentPage = 0, currentPageSize = 10} = input
    const result = await client.car.guestList.query({
      filters: unref(filters),
      pageInfo: {
        skip: Math.max(0, (currentPage - 1) * currentPageSize),
        take: currentPageSize || 10
      }
    })

    data.value = result.items
    total.value = result.pageInfo.totalCount

    isLoading.value = false
  }

  await fetchData()


  watch(filters, async () => {
    await fetchData({
      // currentPage: currentPage.value,
      // currentPageSize: currentPageSize.value,
      filters: filters.value
    })
  }, {deep: true})

  return {
    filters,
    data,
    isLoading,
    currentPage,
    currentPageSize,
    pageCount,
    isFirstPage,
    isLastPage,
    prev,
    next,
    total,
  }
}


export const useGuestCar = (filter) => {
  const client = useClient()

  const input = {...filter};
  let result = client.car.guestItem.useQuery(input, {})

  const refresh = async () => {
    result = client.car.guestItem.useQuery(input, {});
  }
  const {data, error, pending} = result
  return [data, error, pending, refresh]
}
